import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/automatic.svg'
import _imports_1 from '../assets/icons/invoice.svg'
import _imports_2 from '../assets/icons/ic_card.svg'
import _imports_3 from '../assets/logo-pdf.png'


const _withScopeId = n => (_pushScopeId("data-v-3666860a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "amountdue-section" }
const _hoisted_4 = { class: "mt-3 amount-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-title float-start" }, "Amount Due Today", -1))
const _hoisted_6 = { class: "payment-amount float-end" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1))
const _hoisted_8 = { class: "heading-subtitle" }
const _hoisted_9 = { class: "amount-row row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Automatic (ACH)",
  src: _imports_0,
  class: "w-auto"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "automatic-text ms-2" }, "Automatic (ACH)", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Check",
  src: _imports_1,
  class: "w-auto"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "automatic-text ms-2" }, "Check", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Check",
  src: _imports_2,
  class: "w-auto"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "automatic-text ms-2" }, "Credit/Debit Card", -1))
const _hoisted_16 = {
  key: 0,
  class: "heading-title banking-details mt-3"
}
const _hoisted_17 = {
  key: 1,
  class: "heading-title banking-details mt-3"
}
const _hoisted_18 = {
  key: 2,
  class: "heading-title banking-details mt-3"
}
const _hoisted_19 = {
  key: 3,
  class: "automatic-data"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group mb-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "routingNumber",
  class: "form-label"
}, "Routing Number * ", -1))
const _hoisted_24 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group mb-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "bankName",
  class: "form-label"
}, "Bank Name *", -1))
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group mb-3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "accountNumber",
  class: "form-label"
}, "Account Number * ", -1))
const _hoisted_32 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "form-group mb-3" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "verifyAccountNumber",
  class: "form-label"
}, "Verify Account Number * ", -1))
const _hoisted_36 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group mb-3" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "accountHolderName",
  class: "form-label"
}, "Account Holder Name * ", -1))
const _hoisted_41 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "form-group mb-3" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "accountType",
  class: "form-label"
}, "Account Type * ", -1))
const _hoisted_45 = { class: "select-box" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select an Account", -1))
const _hoisted_47 = ["value"]
const _hoisted_48 = ["value"]
const _hoisted_49 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_50 = {
  key: 4,
  class: "invoice-data mb-2"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("p", null, " a. Please make all checks payable to P&A Administrative Services, Inc. "),
    /*#__PURE__*/_createElementVNode("p", null, " b. Write the Confirmation Number on your check (Confirmation Number will be on your confirmation once the enrollment is submitted). "),
    /*#__PURE__*/_createElementVNode("p", null, "c. Payments are to be sent to:"),
    /*#__PURE__*/_createElementVNode("div", { class: "ms-4 payment-address mb-3" }, [
      /*#__PURE__*/_createTextVNode(" P&A Administrative Services, Inc."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Department 383"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" P.O. Box 8000"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Buffalo, NY 14267 ")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, " d. The check information will be on your confirmation once the enrollment is submitted. ")
  ])
], -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  key: 5,
  class: "invoice-data mb-2"
}
const _hoisted_54 = { class: "card-info" }
const _hoisted_55 = { class: "amountdue-section mt-2 mb-4" }
const _hoisted_56 = { class: "mt-3 amount-content" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-title float-start" }, "Monthly Premium", -1))
const _hoisted_58 = { class: "payment-amount float-end" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "month-font" }, "Month", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1))
const _hoisted_61 = { class: "heading-subtitle" }
const _hoisted_62 = { class: "amount-row row" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Automatic (ACH)",
  src: _imports_0,
  class: "w-auto"
}, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "automatic-text ms-2" }, "Automatic (ACH)", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Invoice",
  src: _imports_1,
  class: "w-auto"
}, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "automatic-text ms-2" }, "Invoice", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Invoice",
  src: _imports_2,
  class: "w-auto"
}, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "automatic-text ms-2" }, "Credit/Debit Card", -1))
const _hoisted_69 = {
  key: 0,
  class: "heading-title banking-details mt-3"
}
const _hoisted_70 = {
  key: 1,
  class: "heading-title banking-details mt-3"
}
const _hoisted_71 = {
  key: 2,
  class: "heading-title banking-details mt-3"
}
const _hoisted_72 = {
  key: 3,
  class: "row"
}
const _hoisted_73 = { class: "col" }
const _hoisted_74 = { class: "form-group mb-3" }
const _hoisted_75 = { class: "form-check-group" }
const _hoisted_76 = { class: "form-check-inline" }
const _hoisted_77 = {
  key: 0,
  class: "form-check-label",
  for: "sameAsProfile"
}
const _hoisted_78 = { key: 0 }
const _hoisted_79 = {
  key: 1,
  class: "form-check-label",
  for: "sameAddress"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Same as the banking details provided above.", -1))
const _hoisted_81 = {
  key: 4,
  class: "invoice-data mb-2"
}
const _hoisted_82 = { class: "card-info" }
const _hoisted_83 = {
  key: 5,
  class: "invoice-data mb-2"
}
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "col-md-6" }
const _hoisted_86 = { class: "form-group mb-3" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "country",
  class: "form-label"
}, "Country *", -1))
const _hoisted_88 = { class: "select-box" }
const _hoisted_89 = ["disabled"]
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Select a Country", -1))
const _hoisted_91 = ["value"]
const _hoisted_92 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_93 = { class: "col-md-6" }
const _hoisted_94 = { class: "form-group mb-3" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "addressLine1",
  class: "form-label"
}, "Address Line 1 * ", -1))
const _hoisted_96 = ["disabled"]
const _hoisted_97 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "col-md-6" }
const _hoisted_100 = { class: "form-group mb-3" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "addressLine2",
  class: "form-label"
}, "Address Line 2 ", -1))
const _hoisted_102 = ["disabled"]
const _hoisted_103 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_104 = { class: "form-group mb-3" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "form-label"
}, "City *", -1))
const _hoisted_106 = ["disabled"]
const _hoisted_107 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_108 = {
  key: 0,
  class: "row"
}
const _hoisted_109 = { class: "col-md-6" }
const _hoisted_110 = { class: "form-group mb-3" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "form-label"
}, "State *", -1))
const _hoisted_112 = { class: "select-box" }
const _hoisted_113 = ["disabled"]
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Select a State", -1))
const _hoisted_115 = ["value"]
const _hoisted_116 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_117 = { class: "col-md-6" }
const _hoisted_118 = { class: "form-group mb-3" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "zipCode",
  class: "form-label"
}, "Zip Code *", -1))
const _hoisted_120 = ["disabled"]
const _hoisted_121 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_122 = {
  key: 6,
  class: "automatic-data"
}
const _hoisted_123 = { class: "row" }
const _hoisted_124 = { class: "col-md-6" }
const _hoisted_125 = { class: "form-group mb-3" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "routingNumber-mp",
  class: "form-label"
}, "Routing Number * ", -1))
const _hoisted_127 = ["disabled"]
const _hoisted_128 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_129 = { class: "col-md-6" }
const _hoisted_130 = { class: "form-group mb-3" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "bankName-mp",
  class: "form-label"
}, "Bank Name *", -1))
const _hoisted_132 = { class: "row" }
const _hoisted_133 = { class: "col-md-6" }
const _hoisted_134 = { class: "form-group mb-3" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "accountNumber-mp",
  class: "form-label"
}, "Account Number * ", -1))
const _hoisted_136 = ["disabled"]
const _hoisted_137 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_138 = { class: "col-md-6" }
const _hoisted_139 = { class: "form-group mb-3" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "verifyAccountNumber-mp",
  class: "form-label"
}, "Verify Account Number * ", -1))
const _hoisted_141 = ["disabled"]
const _hoisted_142 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_143 = { class: "row" }
const _hoisted_144 = { class: "col-md-6" }
const _hoisted_145 = { class: "form-group mb-3" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "accountHolderName-mp",
  class: "form-label"
}, "Account Holder Name * ", -1))
const _hoisted_147 = ["disabled"]
const _hoisted_148 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_149 = { class: "col-md-6" }
const _hoisted_150 = { class: "form-group mb-3" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "accountType-mp",
  class: "form-label"
}, "Account Type * ", -1))
const _hoisted_152 = { class: "select-box" }
const _hoisted_153 = ["disabled"]
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select an Account", -1))
const _hoisted_155 = ["value"]
const _hoisted_156 = ["value"]
const _hoisted_157 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_158 = {
  id: "pdfContentContainer",
  style: {"display":"none"}
}
const _hoisted_159 = { id: "pdfContent" }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "pdf-logo"
}, null, -1))
const _hoisted_161 = {
  class: "heading-title-for-print",
  id: "print-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationTable = _resolveComponent("ConfirmationTable")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_ConfirmationSave = _resolveComponent("ConfirmationSave")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _cache[55] || (_cache[55] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitHandler && _ctx.submitHandler(...args)), ["prevent"]))
      }, [
        (_ctx.isFormInvalid)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "alert alert-danger",
              innerHTML: _ctx.validationMsg
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("aside", _hoisted_6, " $" + _toDisplayString(_ctx.totalPayment(_ctx.payments.amountDueToday, _ctx.cardChecked)), 1),
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.subHeading(_ctx.payments.amountDueToday)), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", {
                class: _normalizeClass(["automatic-amount p-2 col-md-6", { active: _ctx.achChecked }])
              }, [
                _hoisted_10,
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input checkbox-size automatic-chckbox",
                  id: "automatic",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.achChecked) = $event)),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleAmountCheckboxClick && _ctx.handleAmountCheckboxClick(...args)))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.achChecked]
                ])
              ], 2),
              _createElementVNode("label", {
                class: _normalizeClass(["automatic-amount p-2 col-md-6 ms-sm-2", { active: _ctx.checkChecked }])
              }, [
                _hoisted_12,
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input checkbox-size invoice-checkbox",
                  id: "invoice",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkChecked) = $event)),
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleCheckaAmountCheckboxClick && _ctx.handleCheckaAmountCheckboxClick(...args)))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.checkChecked]
                ])
              ], 2),
              (_ctx.isStripeEnabled)
                ? (_openBlock(), _createElementBlock("label", {
                    key: 0,
                    class: _normalizeClass(["automatic-amount p-2 col-md-6 ms-sm-2", { active: _ctx.cardChecked }])
                  }, [
                    _hoisted_14,
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input checkbox-size invoice-checkbox",
                      id: "invoice",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cardChecked) = $event)),
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleCardCheckboxClick && _ctx.handleCardCheckboxClick(...args)))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.cardChecked]
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            (_ctx.checkChecked)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_16, " Billing Address "))
              : _createCommentVNode("", true),
            (_ctx.achChecked)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_17, " Banking Details "))
              : _createCommentVNode("", true),
            (_ctx.cardChecked && _ctx.isStripeEnabled)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_18, " Credit/Debit Card "))
              : _createCommentVNode("", true),
            (_ctx.achChecked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "9",
                          id: "routingNumber",
                          class: _normalizeClass(["form-control number-font", 
                      _ctx.v$.payment.amountDueToday.routingNumber.$error
                        ? 'is-invalid'
                        : ''
                    ]),
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payment.amountDueToday.routingNumber) = $event)),
                          onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getFederalAch(_ctx.payments.amountDueToday))),
                          onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateMonthlyBankDetails()))
                        }, null, 34), [
                          [_vModelText, _ctx.payment.amountDueToday.routingNumber]
                        ]),
                        (_ctx.v$.payment.amountDueToday.routingNumber.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              (_ctx.v$.payment.amountDueToday.routingNumber.required)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.amountDueToday.routingNumber.$error,
                      })
                                  }, " Please enter a valid routing number ", 2))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "bankName",
                          disabled: "",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.payment.amountDueToday.bankName) = $event)),
                          onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.payment.amountDueToday.bankName.$touch())),
                          onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateMonthlyBankDetails()))
                        }, null, 544), [
                          [_vModelText, _ctx.payment.amountDueToday.bankName]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "30",
                          id: "accountNumber",
                          class: _normalizeClass(["form-control number-font", 
                      _ctx.v$.payment.amountDueToday.accountNumber.$error
                        ? 'is-invalid'
                        : ''
                    ]),
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.payment.amountDueToday.accountNumber) = $event)),
                          onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.v$.payment.amountDueToday.accountNumber.$touch())),
                          onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updateMonthlyBankDetails()))
                        }, null, 34), [
                          [_vModelText, _ctx.payment.amountDueToday.accountNumber]
                        ]),
                        (_ctx.v$.payment.amountDueToday.accountNumber.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              (_ctx.v$.payment.amountDueToday.accountNumber.required)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.amountDueToday.accountNumber.$error,
                      })
                                  }, " Please enter a valid account number ", 2))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "30",
                          id: "verifyAccountNumber",
                          class: _normalizeClass(["form-control number-font", 
                      _ctx.v$.payment.amountDueToday.verifyAccountNumber.$error
                        ? 'is-invalid'
                        : ''
                    ]),
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.payment.amountDueToday.verifyAccountNumber) = $event)),
                          onInput: _cache[16] || (_cache[16] = ($event: any) => (
                      _ctx.v$.payment.amountDueToday.verifyAccountNumber.$touch()
                    )),
                          onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updateMonthlyBankDetails()))
                        }, null, 34), [
                          [_vModelText, _ctx.payment.amountDueToday.verifyAccountNumber]
                        ]),
                        (_ctx.v$.payment.amountDueToday.verifyAccountNumber.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _createElementVNode("span", {
                                class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.amountDueToday.verifyAccountNumber.$error
                            .sameAsAccountNumber ||
                          _ctx.v$.payment.amountDueToday.verifyAccountNumber.required
                            .$invalid,
                      })
                              }, " Please enter a valid account number ", 2)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "60",
                          id: "accountHolderName",
                          class: _normalizeClass(["form-control", 
                      _ctx.v$.payment.amountDueToday.accountHolderName.$error
                        ? 'is-invalid'
                        : ''
                    ]),
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.payment.amountDueToday.accountHolderName) = $event)),
                          onInput: _cache[19] || (_cache[19] = ($event: any) => (
                      _ctx.v$.payment.amountDueToday.accountHolderName.$touch()
                    )),
                          onBlur: _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateMonthlyBankDetails()))
                        }, null, 34), [
                          [_vModelText, _ctx.payment.amountDueToday.accountHolderName]
                        ]),
                        (_ctx.v$.payment.amountDueToday.accountHolderName.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              (
                        _ctx.v$.payment.amountDueToday.accountHolderName.required
                          .$invalid
                      )
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.amountDueToday.accountHolderName.$error,
                      })
                                  }, " Please enter a valid account holder name ", 2))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createElementVNode("div", _hoisted_45, [
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["form-control", 
                        _ctx.v$.payment.amountDueToday.accountType.$error
                          ? 'is-invalid'
                          : ''
                      ]),
                            id: "accountType",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.payment.amountDueToday.accountType) = $event)),
                            onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.updateMonthlyBankDetails('accountType')))
                          }, [
                            _hoisted_46,
                            _createElementVNode("option", {
                              value: _ctx.accountTypes.Check
                            }, "Checking", 8, _hoisted_47),
                            _createElementVNode("option", {
                              value: _ctx.accountTypes.Savings
                            }, "Savings", 8, _hoisted_48)
                          ], 34), [
                            [_vModelSelect, _ctx.payment.amountDueToday.accountType]
                          ])
                        ]),
                        (_ctx.v$.payment.amountDueToday.accountType.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              (
                        _ctx.v$.payment.amountDueToday.accountType.required.$invalid
                      )
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.amountDueToday.accountType.$error,
                      })
                                  }, " Please enter a valid account type ", 2))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.checkChecked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
              : _createCommentVNode("", true),
            (_ctx.cardChecked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createTextVNode(" P&A offers the option to pay by credit/debit card as an alternative form of payment to ACH or check. If you choose to pay using a credit/debit card, A convenience fee will apply: "),
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, "$" + _toDisplayString(_ctx.convenienceFee) + " per transaction", 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("section", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _createElementVNode("aside", _hoisted_58, [
              _createTextVNode(" $" + _toDisplayString(_ctx.totalPayment(_ctx.payments.monthlyPremium, _ctx.cardMPChecked)) + "/", 1),
              _hoisted_59
            ]),
            _hoisted_60,
            _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.subHeading(_ctx.payments.monthlyPremium)), 1),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("label", {
                class: _normalizeClass(["automatic-amount p-2 col-md-6", { active: _ctx.automaticCheckboxChecked }])
              }, [
                _hoisted_63,
                _hoisted_64,
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input checkbox-size automatic-chckbox",
                  id: "automatic",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.automaticCheckboxChecked) = $event)),
                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.handleAutomaticCheckboxClick && _ctx.handleAutomaticCheckboxClick(...args)))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.automaticCheckboxChecked]
                ])
              ], 2),
              _createElementVNode("label", {
                class: _normalizeClass(["automatic-amount p-2 col-md-6 ms-sm-2", { active: _ctx.invoiceCheckboxChecked }])
              }, [
                _hoisted_65,
                _hoisted_66,
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input checkbox-size invoice-checkbox",
                  id: "invoice",
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.invoiceCheckboxChecked) = $event)),
                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.handleInvoiceCheckboxClick && _ctx.handleInvoiceCheckboxClick(...args)))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.invoiceCheckboxChecked]
                ])
              ], 2),
              false
                ? (_openBlock(), _createElementBlock("label", {
                    key: 0,
                    class: _normalizeClass(["automatic-amount p-2 col-md-6 ms-sm-2", { active: _ctx.cardMPChecked }])
                  }, [
                    _hoisted_67,
                    _hoisted_68,
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input checkbox-size invoice-checkbox",
                      id: "invoice",
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.cardMPChecked) = $event)),
                      onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.handleCardMPCheckboxClick && _ctx.handleCardMPCheckboxClick(...args)))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.cardMPChecked]
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            (_ctx.invoiceCheckboxChecked)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_69, " Billing Address "))
              : _createCommentVNode("", true),
            (_ctx.cardMPChecked && _ctx.isStripeEnabled)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_70, " Credit/Debit Card "))
              : _createCommentVNode("", true),
            (_ctx.automaticCheckboxChecked)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_71, " Banking Details "))
              : _createCommentVNode("", true),
            (
              !_ctx.cardMPChecked &&
              (_ctx.invoiceCheckboxChecked ||
                (!_ctx.v$.payment.amountDueToday.$invalid &&
                  _ctx.achChecked &&
                  _ctx.automaticCheckboxChecked))
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          (_ctx.invoiceCheckboxChecked)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_77, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  class: "form-check-input",
                                  id: "sameAsProfile",
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.sameAsProfile) = $event)),
                                  onChange: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.updateAddress && _ctx.updateAddress(...args)))
                                }, null, 544), [
                                  [_vModelCheckbox, _ctx.sameAsProfile]
                                ]),
                                (_ctx.invoiceCheckboxChecked)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_78, "Same as address provided in the profile information"))
                                  : _createCommentVNode("", true)
                              ]))
                            : (
                        !_ctx.v$.payment.amountDueToday.$invalid && _ctx.achChecked
                      )
                              ? (_openBlock(), _createElementBlock("label", _hoisted_79, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    class: "form-check-input",
                                    id: "sameAddress",
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.copyAboveAddressCheckbox) = $event)),
                                    onChange: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.copyDueTodayToMonthlyAutomatic && _ctx.copyDueTodayToMonthlyAutomatic(...args)))
                                  }, null, 544), [
                                    [_vModelCheckbox, _ctx.copyAboveAddressCheckbox]
                                  ]),
                                  _hoisted_80
                                ]))
                              : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.cardMPChecked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _createTextVNode(" P&A offers the option to pay by credit/debit card as an alternative form of payment to ACH or check. If you choose to pay using a credit/debit card, A convenience fee will apply: "),
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, "$" + _toDisplayString(_ctx.convenienceFee) + " per transaction", 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (
              _ctx.invoiceCheckboxChecked &&
              _ctx.monthlyPremiumMethod() === _ctx.paymentType.invoice
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _hoisted_87,
                        _createElementVNode("div", _hoisted_88, [
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["form-control", 
                        _ctx.v$.payment.monthlyPremium.invoice.countryId.$error
                          ? 'is-invalid'
                          : ''
                      ]),
                            id: "country",
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.payment.monthlyPremium.invoice.countryId) = $event)),
                            onChange: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.changeCountry && _ctx.changeCountry(...args))),
                            disabled: _ctx.disableAddress
                          }, [
                            _hoisted_90,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCountries, (country) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: 'option-' + country.countryId,
                                value: country.countryId
                              }, _toDisplayString(country.countryName), 9, _hoisted_91))
                            }), 128))
                          ], 42, _hoisted_89), [
                            [_vModelSelect, _ctx.payment.monthlyPremium.invoice.countryId]
                          ])
                        ]),
                        (_ctx.v$.payment.monthlyPremium.invoice.countryId.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                              (
                        _ctx.v$.payment.monthlyPremium.invoice.countryId.required
                      )
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.monthlyPremium.invoice.countryId.$error,
                      })
                                  }, " Please enter a valid country name ", 2))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _hoisted_95,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "50",
                          id: "addressLine1",
                          class: _normalizeClass(["form-control type-number", 
                      _ctx.v$.payment.monthlyPremium.invoice.addressLine1.$error
                        ? 'is-invalid'
                        : ''
                    ]),
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.payment.monthlyPremium.invoice.addressLine1) = $event)),
                          onInput: _cache[36] || (_cache[36] = ($event: any) => (
                      _ctx.v$.payment.monthlyPremium.invoice.addressLine1.$touch()
                    )),
                          disabled: _ctx.disableAddress
                        }, null, 42, _hoisted_96), [
                          [_vModelText, _ctx.payment.monthlyPremium.invoice.addressLine1]
                        ]),
                        (_ctx.v$.payment.monthlyPremium.invoice.addressLine1.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                              (
                        _ctx.v$.payment.monthlyPremium.invoice.addressLine1.required
                      )
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.monthlyPremium.invoice.addressLine1.$error,
                      })
                                  }, " Please enter a valid address ", 2))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", _hoisted_100, [
                        _hoisted_101,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "50",
                          id: "addressLine2",
                          class: "form-control type-number",
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.payment.monthlyPremium.invoice.addressLine2) = $event)),
                          disabled: _ctx.disableAddress
                        }, null, 8, _hoisted_102), [
                          [_vModelText, _ctx.payment.monthlyPremium.invoice.addressLine2]
                        ])
                      ])
                    ]),
                    (
                  _ctx.payment.monthlyPremium.invoice.countryId !== _ctx.countries.OTH
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                          _createElementVNode("div", _hoisted_104, [
                            _hoisted_105,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "50",
                              id: "city",
                              class: _normalizeClass(["form-control", 
                      _ctx.v$.payment.monthlyPremium.invoice.city.$error
                        ? 'is-invalid'
                        : ''
                    ]),
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.payment.monthlyPremium.invoice.city) = $event)),
                              onInput: _cache[39] || (_cache[39] = ($event: any) => (_ctx.v$.payment.monthlyPremium.invoice.city.$touch())),
                              disabled: _ctx.disableAddress
                            }, null, 42, _hoisted_106), [
                              [_vModelText, _ctx.payment.monthlyPremium.invoice.city]
                            ]),
                            (_ctx.v$.payment.monthlyPremium.invoice.city.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                  (
                        _ctx.v$.payment.monthlyPremium.invoice.city
                          .requiredIfCountryNotOther
                      )
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.monthlyPremium.invoice.city.$error,
                      })
                                      }, " Please enter a valid city name ", 2))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.payment.monthlyPremium.invoice.countryId !== _ctx.countries.OTH)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                        _createElementVNode("div", _hoisted_109, [
                          _createElementVNode("div", _hoisted_110, [
                            _hoisted_111,
                            _createElementVNode("div", _hoisted_112, [
                              _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["form-control", 
                        _ctx.v$.payment.monthlyPremium.invoice.geoStateId.$error
                          ? 'is-invalid'
                          : ''
                      ]),
                                id: "state",
                                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.payment.monthlyPremium.invoice.geoStateId) = $event)),
                                onChange: _cache[41] || (_cache[41] = ($event: any) => (
                        _ctx.v$.payment.monthlyPremium.invoice.geoStateId.$touch()
                      )),
                                disabled: _ctx.disableAddress
                              }, [
                                _hoisted_114,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allStatesOptions, (state) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: 'option-' + state.geoStateId,
                                    value: state.geoStateId
                                  }, _toDisplayString(state.geoStateName), 9, _hoisted_115))
                                }), 128))
                              ], 42, _hoisted_113), [
                                [_vModelSelect, _ctx.payment.monthlyPremium.invoice.geoStateId]
                              ])
                            ]),
                            (_ctx.v$.payment.monthlyPremium.invoice.geoStateId.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                  (
                        _ctx.v$.payment.monthlyPremium.invoice.geoStateId
                          .requiredIfCountryNotOther
                      )
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.monthlyPremium.invoice.geoStateId.$error,
                      })
                                      }, " Please enter a valid state ", 2))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_117, [
                          _createElementVNode("div", _hoisted_118, [
                            _hoisted_119,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              id: "zipCode",
                              class: _normalizeClass(["form-control type-number", 
                      _ctx.v$.payment.monthlyPremium.invoice.zipCode.$error
                        ? 'is-invalid'
                        : ''
                    ]),
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.payment.monthlyPremium.invoice.zipCode) = $event)),
                              onInput: _cache[43] || (_cache[43] = ($event: any) => (_ctx.v$.payment.monthlyPremium.invoice.zipCode.$touch())),
                              disabled: _ctx.disableAddress
                            }, null, 42, _hoisted_120), [
                              [_vModelText, _ctx.payment.monthlyPremium.invoice.zipCode]
                            ]),
                            (_ctx.v$.payment.monthlyPremium.invoice.zipCode.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                  (
                        _ctx.v$.payment.monthlyPremium.invoice.zipCode
                          .requiredIfCountryNotOther
                      )
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.monthlyPremium.invoice.zipCode.$error,
                      })
                                      }, " Please enter a valid zip code ", 2))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (
              _ctx.automaticCheckboxChecked &&
              _ctx.monthlyPremiumMethod() === _ctx.paymentType.ach
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                  _createElementVNode("div", _hoisted_123, [
                    _createElementVNode("div", _hoisted_124, [
                      _createElementVNode("div", _hoisted_125, [
                        _hoisted_126,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "routingNumber-mp",
                          maxlength: "9",
                          class: _normalizeClass(["form-control number-font", 
                      _ctx.v$.payment.monthlyPremium.ach.routingNumber.$error
                        ? 'is-invalid'
                        : ''
                    ]),
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.payment.monthlyPremium.ach.routingNumber) = $event)),
                          onInput: _cache[45] || (_cache[45] = ($event: any) => (_ctx.getFederalAch(_ctx.payments.monthlyPremium))),
                          disabled: _ctx.disableBankDetails
                        }, null, 42, _hoisted_127), [
                          [_vModelText, _ctx.payment.monthlyPremium.ach.routingNumber]
                        ]),
                        (_ctx.v$.payment.monthlyPremium.ach.routingNumber.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                              (
                        _ctx.v$.payment.monthlyPremium.ach.routingNumber.required
                      )
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.monthlyPremium.ach.routingNumber.$error,
                      })
                                  }, " Please enter a valid routing number ", 2))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_129, [
                      _createElementVNode("div", _hoisted_130, [
                        _hoisted_131,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "bankName-mp",
                          class: "form-control",
                          disabled: "",
                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.payment.monthlyPremium.ach.bankName) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.payment.monthlyPremium.ach.bankName]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_132, [
                    _createElementVNode("div", _hoisted_133, [
                      _createElementVNode("div", _hoisted_134, [
                        _hoisted_135,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "30",
                          id: "accountNumber-mp",
                          class: _normalizeClass(["form-control number-font", 
                      _ctx.v$.payment.monthlyPremium.ach.accountNumber.$error
                        ? 'is-invalid'
                        : ''
                    ]),
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.payment.monthlyPremium.ach.accountNumber) = $event)),
                          onInput: _cache[48] || (_cache[48] = ($event: any) => (
                      _ctx.v$.payment.monthlyPremium.ach.accountNumber.$touch()
                    )),
                          disabled: _ctx.disableBankDetails
                        }, null, 42, _hoisted_136), [
                          [_vModelText, _ctx.payment.monthlyPremium.ach.accountNumber]
                        ]),
                        (_ctx.v$.payment.monthlyPremium.ach.accountNumber.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                              (
                        _ctx.v$.payment.monthlyPremium.ach.accountNumber.required
                      )
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.monthlyPremium.ach.accountNumber.$error,
                      })
                                  }, " Please enter a valid account number ", 2))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_138, [
                      _createElementVNode("div", _hoisted_139, [
                        _hoisted_140,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "30",
                          id: "verifyAccountNumber-mp",
                          class: _normalizeClass(["form-control number-font", 
                      _ctx.v$.payment.monthlyPremium.ach.verifyAccountNumber.$error
                        ? 'is-invalid'
                        : ''
                    ]),
                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.payment.monthlyPremium.ach.verifyAccountNumber) = $event)),
                          onInput: _cache[50] || (_cache[50] = ($event: any) => (
                      _ctx.v$.payment.monthlyPremium.ach.verifyAccountNumber.$touch()
                    )),
                          disabled: _ctx.disableBankDetails
                        }, null, 42, _hoisted_141), [
                          [_vModelText, _ctx.payment.monthlyPremium.ach.verifyAccountNumber]
                        ]),
                        (
                      _ctx.v$.payment.monthlyPremium.ach.verifyAccountNumber.$error
                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                              (
                        _ctx.v$.payment.monthlyPremium.ach.verifyAccountNumber
                          .required
                      )
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.monthlyPremium.ach.verifyAccountNumber
                            .$error,
                      })
                                  }, " Please enter a valid account number ", 2))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_143, [
                    _createElementVNode("div", _hoisted_144, [
                      _createElementVNode("div", _hoisted_145, [
                        _hoisted_146,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "60",
                          id: "accountHolderName-mp",
                          class: _normalizeClass(["form-control", 
                      _ctx.v$.payment.monthlyPremium.ach.accountHolderName.$error
                        ? 'is-invalid'
                        : ''
                    ]),
                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.payment.monthlyPremium.ach.accountHolderName) = $event)),
                          onInput: _cache[52] || (_cache[52] = ($event: any) => (
                      _ctx.v$.payment.monthlyPremium.ach.accountHolderName.$touch()
                    )),
                          disabled: _ctx.disableBankDetails
                        }, null, 42, _hoisted_147), [
                          [_vModelText, _ctx.payment.monthlyPremium.ach.accountHolderName]
                        ]),
                        (
                      _ctx.v$.payment.monthlyPremium.ach.accountHolderName.$error
                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                              (
                        _ctx.v$.payment.monthlyPremium.ach.accountHolderName.required
                      )
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.monthlyPremium.ach.accountHolderName
                            .$error,
                      })
                                  }, " Please enter a valid account holder name ", 2))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_149, [
                      _createElementVNode("div", _hoisted_150, [
                        _hoisted_151,
                        _createElementVNode("div", _hoisted_152, [
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["form-control", 
                        _ctx.v$.payment.monthlyPremium.ach.accountType.$error
                          ? 'is-invalid'
                          : ''
                      ]),
                            id: "accountType-mp",
                            "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.payment.monthlyPremium.ach.accountType) = $event)),
                            onChange: _cache[54] || (_cache[54] = ($event: any) => (
                        _ctx.v$.payment.monthlyPremium.ach.accountType.$touch()
                      )),
                            disabled: _ctx.disableBankDetails
                          }, [
                            _hoisted_154,
                            _createElementVNode("option", {
                              value: _ctx.accountTypes.Check
                            }, "Checking", 8, _hoisted_155),
                            _createElementVNode("option", {
                              value: _ctx.accountTypes.Savings
                            }, "Savings", 8, _hoisted_156)
                          ], 42, _hoisted_153), [
                            [_vModelSelect, _ctx.payment.monthlyPremium.ach.accountType]
                          ])
                        ]),
                        (_ctx.v$.payment.monthlyPremium.ach.accountType.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                              (_ctx.v$.payment.monthlyPremium.ach.accountType.required)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass({
                        'is-invalid':
                          _ctx.v$.payment.monthlyPremium.ach.accountType.$error,
                      })
                                  }, " Please enter a valid account type ", 2))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_158, [
        _createElementVNode("div", _hoisted_159, [
          _hoisted_160,
          _createElementVNode("h1", _hoisted_161, " Your confirmation number is " + _toDisplayString(_ctx.profileData.electionId), 1),
          _createVNode(_component_ConfirmationTable, {
            "profile-data": _ctx.profileData,
            "qualifying-beneficiary-data": _ctx.qualifyingBeneficiaryData,
            "get-state-name": _ctx.getStateName,
            "get-country-name": _ctx.getCountryName,
            "dependent-data": _ctx.dependentData,
            "benefits-data": _ctx.benefitsData,
            "monthly-premium-data": _ctx.monthlyPremiumData,
            "get-monthly-country-name": _ctx.getMonthlyCountryName,
            "get-monthly-state-name": _ctx.getMonthlyStateName,
            "amount-today-data": _ctx.amountTodayData,
            "documents-data": _ctx.documentsData,
            "modify-btn": false,
            "gender-options": _ctx.genderOptions,
            countries: _ctx.countries,
            "payment-methods": _ctx.paymentMethods,
            "account-types": _ctx.accountTypes,
            "card-detail": _ctx.cardDetail
          }, null, 8, ["profile-data", "qualifying-beneficiary-data", "get-state-name", "get-country-name", "dependent-data", "benefits-data", "monthly-premium-data", "get-monthly-country-name", "get-monthly-state-name", "amount-today-data", "documents-data", "gender-options", "countries", "payment-methods", "account-types", "card-detail"])
        ])
      ])
    ]),
    _createVNode(_component_AppFooter, {
      "save-btn-txt": 
      _ctx.isStripeEnabled &&
      (_ctx.amountDuePayMethod() === _ctx.common.paymentMethods.Card ||
        _ctx.monthlyPremiumMethod() === _ctx.common.paymentMethods.Card)
        ? 'NEXT'
        : 'SUBMIT'
    ,
      id: "submitButton",
      onSubmitHandler: _ctx.submitHandler,
      "is-form-invalid": _ctx.isValidForm(),
      "is-submit-disabled": _ctx.isSubmitDisabled,
      "tool-tip": "Please update payment information to proceed"
    }, null, 8, ["save-btn-txt", "onSubmitHandler", "is-form-invalid", "is-submit-disabled"]),
    _createVNode(_component_ConfirmationSave, {
      visible: _ctx.showConfirmationModal,
      onClose: _ctx.closeConfirmationModal,
      onConfirmEnrollment: _ctx.confirmEnrollment
    }, null, 8, ["visible", "onClose", "onConfirmEnrollment"])
  ], 64))
}